/* Grondyke · Discovery Pack landing page (/pages/discovery-pack).

   The buy box owns ONE piece of state: the selected scent set (0 / 1 / 2). There is no pack
   selector on this page: it asks the single question the ad has already set up, at one fixed
   price. Everything else on the page that depends on the set is rendered by Liquid with all
   three values on the element itself (data-v0 / data-v1 / data-v2) and swapped here, so a
   section never has to be re-fetched and no value can drift out of step with the picture
   beside it.

   Downstream CTAs NAVIGATE, they never write buy-box state. The buy box sells one product at
   one price, so a downstream control that changed the selection desynchronised the price block
   and asserted a markdown that was never offered.

   POST-ADD UPSELL · a LINE SWAP, not an add. The Kit is its own Shopify product:
       soap 3-pack $29.95 + solid cologne 3-pack $24.64 = $54.59   <- NOT the offer
       the Kit product                                    $49.95   <- the offer, +$20 exactly
   Accepting therefore sets the soap line to quantity 0 and adds the Kit variant. Adding the
   colognes as a second line item would produce a $54.59 cart and make the modal's headline a
   lie. If the Kit add fails after the removal, the soap line is put back rather than leaving
   an empty cart behind.

   Every exit from the modal goes to /cart, because the item is already in the cart by the time
   it renders: dismissing back to the landing page would leave a buyer looking at the page that
   sold it to them with no sign anything happened. It opens once per session.
*/
(function () {
  'use strict';

  var ONCE_KEY = 'gk_dp_upsell';
  var cfg = { cartAddUrl: '/cart/add', cartChangeUrl: '/cart/change', cartUrl: '/cart' };
  var set = 0;

  function seen() { try { return sessionStorage.getItem(ONCE_KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(ONCE_KEY, '1'); } catch (e) {} }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  /* Eurus keeps the header count and drawer in an Alpine store. Nudge it where it exists; the
     page navigates to /cart afterwards regardless. */
  function refreshCart() {
    try { document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); } catch (e) {}
  }

  /* One generic swap. Every set-dependent value in the page is an attribute on its own element,
     so adding a section that follows the scent set needs no change here. */
  function applySet(i) {
    var v = 'data-v' + i;
    [].forEach.call(document.querySelectorAll('[data-gk-dp-var]'), function (el) {
      var t = el.getAttribute(v);
      el.textContent = t || '';
      if (el.hasAttribute('data-gk-dp-hide-empty')) el.hidden = !t;
    });
    [].forEach.call(document.querySelectorAll('[data-gk-dp-varimg]'), function (el) {
      var src = el.getAttribute(v);
      if (!src || el.getAttribute('src') === src) return;
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
      el.setAttribute('src', src);
      var alt = el.getAttribute('data-alt' + i);
      if (alt != null) el.setAttribute('alt', alt);
    });
    [].forEach.call(document.querySelectorAll('[data-gk-dp-varhref]'), function (el) {
      var href = el.getAttribute(v);
      if (href) el.setAttribute('href', href);
    });
    [].forEach.call(document.querySelectorAll('[data-gk-dp-varval]'), function (el) {
      el.value = el.getAttribute(v) || '';
    });
    [].forEach.call(document.querySelectorAll('[data-gk-dp-avail]'), function (el) {
      var ok = el.getAttribute('data-a' + i) === 'true';
      el.disabled = !ok;
      var label = el.querySelector('[data-gk-dp-atc-label]');
      if (label) label.textContent = ok ? (cfg.atcLabel || label.textContent) : (cfg.soldOut || label.textContent);
    });
  }

  function measureSticky(bar) {
    if (!bar || bar.hidden) return;
    var h = Math.ceil(bar.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--gk-dp-sticky-h', h + 'px');
  }

  function activeVariant() {
    var el = document.querySelector('[data-gk-dp-variant]');
    return el ? el.value : '';
  }

  /* ---------------------------------------------------------------- buy box */
  function initBuy(root) {
    var el = root.querySelector('[data-gk-dp-config]');
    if (el) { try { cfg = Object.assign(cfg, JSON.parse(el.textContent)); } catch (e) {} }

    var rail = root.querySelector('[data-gk-dp-rail]');
    var slides = [].slice.call(root.querySelectorAll('[data-gk-dp-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-gk-dp-thumb]'));
    var rows = [].slice.call(root.querySelectorAll('[data-gk-dp-set]'));
    var form = root.querySelector('[data-gk-dp-form]');
    var atc = root.querySelector('[data-gk-dp-atc]');
    var err = root.querySelector('[data-gk-dp-form-error]');
    var sticky = document.querySelector('[data-gk-dp-sticky]');
    var programmatic = false;

    function render(scrollRail) {
      slides.forEach(function (s, i) {
        var on = i === set;
        s.classList.toggle('is-active', on);
        if (on && scrollRail && rail && rail.scrollWidth > rail.clientWidth + 4) {
          programmatic = true;
          rail.scrollTo({ left: s.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
          setTimeout(function () { programmatic = false; }, 450);
        }
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-on', i === set);
        t.setAttribute('aria-pressed', i === set ? 'true' : 'false');
      });
      rows.forEach(function (r, i) {
        r.classList.toggle('is-on', i === set);
        r.setAttribute('aria-checked', i === set ? 'true' : 'false');
      });
      applySet(set);
    }

    function pick(i, scrollRail) {
      if (i === set || i < 0 || i > 2) return;
      set = i;
      render(scrollRail);
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i, true); }); });
    rows.forEach(function (r, i) { r.addEventListener('click', function () { pick(i, true); }); });

    /* Swiping the rail is a second route into the same choice, not a parallel one: the slide
       the reader lands on becomes the selection, so the price can never disagree with the
       picture above it. */
    if (rail) {
      var timer = null;
      rail.addEventListener('scroll', function () {
        if (programmatic) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestD = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs((s.offsetLeft - rail.offsetLeft + s.offsetWidth / 2) - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          pick(best, false);
        }, 90);
      }, { passive: true });
    }

    /* The sticky bar appears once the buy-box add-to-cart has scrolled away. */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting;
        measureSticky(sticky);
      }, { rootMargin: '0px 0px -60px 0px' }).observe(atc);
    }
    /* Publish the bar's real height so the footer can reserve exactly that much. A hardcoded
       reserve per breakpoint is fragile: one extra line in the product name pushes the bar over
       the footer, and the name here is a Shopify title we do not control. */
    if (sticky) {
      measureSticky(sticky);
      if (window.ResizeObserver) new ResizeObserver(function () { measureSticky(sticky); }).observe(sticky);
      window.addEventListener('resize', function () { measureSticky(sticky); });
    }

    function add(button, errorEl) {
      var id = activeVariant();
      if (!id) return;
      button.disabled = true;
      if (errorEl) errorEl.hidden = true;
      post(cfg.cartAddUrl + '.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error('add failed');
          refreshCart();
          var line = (res.json.items && res.json.items[0]) || res.json;
          var key = line && line.key ? line.key : String(id);
          if (cfg.showUpsell && !seen()) { markSeen(); openModal(key); }
          else { window.location.href = cfg.cartUrl; }
        })
        .catch(function () {
          if (errorEl) { errorEl.textContent = cfg.error; errorEl.hidden = false; }
          button.disabled = false;
        });
    }
    window.__gkDpAdd = add;

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(atc, err); });
    if (sticky) {
      var sb = sticky.querySelector('[data-gk-dp-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { add(sb, err); });
    }

    render(false);
  }

  /* ------------------------------------------------------------ upsell modal */
  var lineKey = null;

  function toCart() { window.location.href = cfg.cartUrl; }

  function openModal(key) {
    var modal = document.querySelector('[data-gk-dp-modal]');
    if (!modal) { toCart(); return; }
    lineKey = key;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = modal.querySelector('[data-gk-dp-modal-cart]');
    if (first) first.focus();
  }

  function initModal(root) {
    var accept = root.querySelector('[data-gk-dp-modal-accept]');
    var err = root.querySelector('[data-gk-dp-modal-error]');
    var kitInput = root.querySelector('[data-gk-dp-modal-variant]');

    root.addEventListener('click', function (e) { if (e.target === root) toCart(); });
    [].forEach.call(root.querySelectorAll('[data-gk-dp-modal-cart],[data-gk-dp-modal-decline]'),
      function (b) { b.addEventListener('click', toCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) toCart(); });

    if (accept) accept.addEventListener('click', function () {
      var kitId = kitInput ? kitInput.value : '';
      var soapId = activeVariant();
      if (!kitId) { toCart(); return; }
      accept.disabled = true;
      if (err) err.hidden = true;
      post(cfg.cartChangeUrl + '.js', { id: lineKey, quantity: 0 })
        .then(function (res) {
          if (!res.ok) throw new Error('remove failed');
          return post(cfg.cartAddUrl + '.js', { items: [{ id: parseInt(kitId, 10), quantity: 1 }] })
            .then(function (add) {
              if (!add.ok || add.json.status) {
                /* Put the soap back rather than leave the buyer with nothing. */
                return post(cfg.cartAddUrl + '.js', { items: [{ id: parseInt(soapId, 10), quantity: 1 }] })
                  .then(function () { throw new Error('kit add failed'); });
              }
              return add;
            });
        })
        .then(function () { refreshCart(); toCart(); })
        .catch(function () {
          if (err) { err.textContent = cfg.error; err.hidden = false; }
          accept.disabled = false;
        });
    });
  }

  /* The final CTA sells the same product as the buy box, so it runs the same add and the same
     one-per-session modal rather than posting its form. */
  function initFinal(root) {
    var form = root.querySelector('[data-gk-dp-final-form]');
    var button = root.querySelector('[data-gk-dp-final-atc]');
    var err = root.querySelector('[data-gk-dp-final-error]');
    if (!form || !button) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (window.__gkDpAdd) window.__gkDpAdd(button, err);
      else form.submit();
    });
  }

  function boot() {
    var buy = document.querySelector('[data-gk-dp-buy]');
    var modal = document.querySelector('[data-gk-dp-modal]');
    var final = document.querySelector('[data-gk-dp-final]');
    if (buy) initBuy(buy); else applySet(0);
    if (modal) initModal(modal);
    if (final) initFinal(final);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
